module.exports = __webpack_public_path__ + "media/src/website/images/locations/fridolfing/fridolfing_02-67147838eeabf8f8341e01f46ce37ebf.jpg";